import Equipment from "features/equipment";

type Props = {};

const EquipmentPage = (props: Props) => {
  return <Equipment />;
};

export default EquipmentPage;
